import type { TopCollectorPageConfig } from '@/app/(football)/[team]/top-collector/_context/types';

export const bluewingsConfig: TopCollectorPageConfig = {
  benefit: {
    captions: [
      '상반기 시즌은 2026년 7월 8일 11:00:00에 종료됩니다.',
      '탑콜렉터 순위는 2026 시즌에 발행한 카드만 포함됩니다.',
      '시즌 종료 시점의 순위를 기준으로 혜택이 지급됩니다.',
      '시즌 종료 후 1주 내 대상자에게는 개별 문자 안내됩니다.\n개인 사유로 인한 미수신으로 발생하는 손해에 대해서는\n당사가 책임을 지지 않습니다.',
      '동일 개수일 경우, 먼저 달성한 유저가 상위에 랭크됩니다.',
      '풀마킹 유니폼은 사이즈 및 선수 마킹 정보를 선택할 수 있습니다.',
      '싸인 액자의 경우 1위는 전 선수 싸인 / 2-3위는 일부 선수 싸인이\n포함된 액자가 전달됩니다. (싸인 선수는 선택할 수 없습니다)',
      '체험 혜택은 2026년 7월 19일 홈 경기에서 제공됩니다.',
      '체험 혜택은 행사 당일 불참 시 대체 일정이 제공되지 않습니다.',
      '굿즈 혜택의 경우 행사 당일 불참 시 별도 배송해드립니다.\n주소 오기입으로 인한 피해는 당사가 책임지지 않습니다.',
      '위 삽입된 상품 이미지는 예시이며, 실제 제공 상품과\n디자인·색상·구성 등이 다를 수 있습니다.',
    ],
    // 하반기(second) 유의사항
    secondSeasonCaptions: [
      '하반기 시즌은 2026년 10월 28일(수) 11:00:00에 종료됩니다.',
      '탑콜렉터 순위는 2026 시즌에 발행한 카드만 포함됩니다.',
      '시즌 종료 시점의 순위를 기준으로 혜택이 지급됩니다.',
      '시즌 종료 후 1주 내 대상자에게는 개별 문자 안내됩니다.\n개인 사유로 인한 미수신으로 발생하는 손해에 대해서는\n당사가 책임을 지지 않습니다.',
      '동일 개수일 경우, 먼저 달성한 유저가 상위에 랭크됩니다.',
      '풀마킹 유니폼은 사이즈 및 선수 마킹 정보를 선택할 수 있습니다.',
      '싸인 액자의 경우 1위는 전 선수 싸인 / 2-3위는 일부 선수 싸인이\n포함된 액자가 전달됩니다. (싸인 선수는 선택할 수 없습니다)',
      '체험 혜택은 2026년 11월 8일 홈 경기에서 제공됩니다.',
      '체험 혜택은 행사 당일 불참 시 대체 일정이 제공되지 않습니다.',
      '굿즈 혜택의 경우 행사 당일 불참 시 별도 배송해드립니다.\n주소 오기입으로 인한 피해는 당사가 책임지지 않습니다.',
      '위 삽입된 상품 이미지는 예시이며, 실제 제공 상품과\n디자인·색상·구성 등이 다를 수 있습니다.',
      '일정 변동 시 본 페이지 팝업 또는 인스타그램을 통해 사전 안내\n드립니다.',
    ],
  },
};
